import { gql } from "graphql-tag";

/**
 *
 * Gets booking ussing uuid
 * Here is a variable example
 * { "uuid": "(uuid,eq,4XcKXvRoAx)" }
 */
export const GET_BookingWithUUID = gql`
  query GETBookingWithUUID($uuid: String!) {
    booking: ProductSlotBookingList(where: $uuid) {
      id: Id
      uid: Uuid
      token: GoerToken
      invoiceId: InvoiceId
      GroupRead {
        groupUuid: Uuid
      }
    }
  }
`;
